import { render, staticRenderFns } from "./sms-list.vue?vue&type=template&id=4198bbf2&scoped=true&"
import script from "./sms-list.vue?vue&type=script&lang=js&"
export * from "./sms-list.vue?vue&type=script&lang=js&"
import style0 from "./sms-list.vue?vue&type=style&index=0&id=4198bbf2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4198bbf2",
  null
  
)

export default component.exports